import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { FormGroup } from '@mui/material'
import { useDispatch } from 'react-redux'
import { themeConfig } from '../config/theme.config'
import { setStartAppTour } from '../slices/tourSlice'
import { setManualStreetMode } from '../slices/appSlice'
import { setDrawerOpen } from '../slices/mainTool'
import { SectionTitle, SubSectionTitle } from './ProjectInputs/ProjectInputs'
import CustomButton from './CustomButton'
import './SplashScreen.scss'
const multimodalLogo = new URL(
  '../../../images/illustrations/SEMCOG-MultiTool-Logo.svg',
  import.meta.url
)
const semcogLogo = new URL(
  '../../../images/icons/SEMCOG-Logo-Lockup.svg',
  import.meta.url
)
const splashIllustration = new URL(
  '../../../images/illustrations/splash-screen-2024-2x.jpg',
  import.meta.url
)

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60vw',

  bgcolor: 'background.paper',
  outline: 'none !important',
  boxShadow: 24,
  p: 4
}

export default function SplashScreen() {
  const [open, setOpen] = React.useState(true)
  const [checked, setChecked] = React.useState(false)
  const dispatch = useDispatch()
  const handleClose = () => setOpen(false)
  const handleTakeTour = () => {
    dispatch(setStartAppTour(true))
    setOpen(false)
  }
  const handleSetupProjectManually = () => {
    dispatch(setManualStreetMode(true))
    dispatch(setDrawerOpen(true))
    setOpen(false)
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: 1000020 }}
    >
      <Box sx={style} className="splashScreen">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{
              height: '38px',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src={semcogLogo}
              style={{
                maxHeight: '50%',
                objectFit: 'cover',
                width: '150px'
              }}
            />
          </Box>
          <Box
            sx={{
              height: '45px',
              display: 'flex',
              gap: '5px',
              alignItems: 'center'
            }}
          >
            <img
              src={multimodalLogo}
              style={{
                width: '40px',
                height: '40px',
                objectFit: 'cover'
              }}
            />
            <SectionTitle
              fontWeight={900}
              fontSize={35}
              color={themeConfig.semcogBlack}
            >
              Multimodal Tool
            </SectionTitle>
          </Box>
          <Box
            sx={{
              width: '70%',
              height: '400px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
            className="splashIllustration"
          >
            <img
              src={splashIllustration}
              style={{
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
            />
          </Box>
          <Box
            sx={{
              width: '90%',

              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <SubSectionTitle fontWeight={400} fontSize={14}>
              Welcome to the Multimodal Tool! Complete streets are a focal point
              for Southeast Michigan communities as they strive to develop
              transportation networks that are safe, convenient, and affordable
              for people of all ages and abilities. Use this tool to test
              complete street designs and understand how they serve people
              walking, biking, driving, riding transit, and moving freight. Take
              the tour to learn more, or launch the app to get started!
              <br /> <br />
              Visit{' '}
              <a href="https://www.semcog.org/mmtool" target="blank">
                https://www.semcog.org/mmtool
              </a>{' '}
              for more information.
            </SubSectionTitle>
          </Box>
          <Box
            sx={{
              width: '90%',

              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '20px'
            }}
          >
            <CustomButton
              handleNext={handleTakeTour}
              btnLabel="Take the Tour"
              justifyContent="center"
              withIcon={true}
              width="100%"
              display="flex"
            />
            <CustomButton
              handleNext={handleClose}
              btnLabel="Launch App"
              justifyContent="center"
              withIcon={true}
              width="100%"
              display="flex"
            />
            <CustomButton
              handleNext={handleSetupProjectManually}
              btnLabel="Setup Project Manually"
              justifyContent="center"
              withIcon={true}
              width="100%"
              display="flex"
            />
          </Box>
          <FormGroup sx={{ m: '0.5em' }}>
            <FormControlLabel
              sx={{
                '& .MuiTypography-root': {
                  color: themeConfig.semcogBlack,
                  fontSize: '14px'
                }
              }}
              control={
                <Checkbox
                  checked={checked}
                  onChange={() => {
                    setChecked(!checked)
                    localStorage.setItem('showSplashScreen', checked)
                  }}
                />
              }
              label="Do not show this dialog again"
            />
          </FormGroup>
        </Box>
      </Box>
    </Modal>
  )
}
